import { PATH } from '@/constants/path';
import { SECTION_SLOGANS, SECTION_TITLES } from '@/constants/products';
import useSpecialProductsHomeQuery from '@/hooks/RQHooks/market/special/useSpecialProductsHomeQuery';
import FeaturedSectionSkeleton from '../../../../components/common/FeaturedSectionSkeleton';
import SectionTitle from '../common/SectionTitle';
import FeaturedProductSection from './FeaturedProductSection';

const SpecialProductSection = () => {
  const { data, isPending } = useSpecialProductsHomeQuery();
  return (
    <div>
      <SectionTitle
        title={SECTION_TITLES.SPECIAL_OFFERS}
        slogan={SECTION_SLOGANS.SPECIAL_OFFERS}
        link={PATH.CATEGORY.SPECIAL}
      />
      {isPending ? (
        <FeaturedSectionSkeleton isSpecialSection />
      ) : (
        <FeaturedProductSection data={data ?? []} isSpecial />
      )}
    </div>
  );
};

export default SpecialProductSection;
